import { envs } from '@config';
import { RestLink } from 'apollo-link-rest';

export const googleAuthMiddleware = new RestLink({
  uri: envs.googleAuthHttpUrl,
});
